import solutions from "@/solutions";

export function loadSolution(mon, day) {
  const key = mon + '-' + day
  const solution = solutions[key]

  const r_month = mon > 6 ? 1 : 0
  const c_month = (mon - 1) % 6
  const r_day = Math.trunc((day - 1) / 7) + 2
  const c_day = (day - 1) % 7
  solution[r_month][c_month] = '0'
  solution[r_day][c_day] = '0'
  return solution
}

export const NON_GRID_CHARACTER = '@'
export const NUM_ROWS = 7
export const NUM_COLS = 7

